import { addErrorNotification, addWarningNotification, NotificationType, OrderDomainError, OrderDomainSpecificErrorCode, removeNotification } from '@vista/omnichannel-components-domain';
import { getIdForComponentNotification } from '../../../../utils/get-id-for-component-notification';
const getNotificationId = (context, type) => {
    return getIdForComponentNotification('ticket-picker', type, context);
};
const seatsUnavailableNotificationId = getNotificationId('seats-unavailable', NotificationType.Warning);
const failedToSaveNotificationId = getNotificationId('failed-to-save', NotificationType.Error);
export const addProceedErrorNotification = (displayText, error) => {
    if (error instanceof OrderDomainError && error.errorCode === OrderDomainSpecificErrorCode.SeatsUnavailable) {
        addWarningNotification({
            id: seatsUnavailableNotificationId,
            messages: [displayText.errorInsufficientSeatsAvailableMessage],
            title: displayText.errorInsufficientSeatsAvailableTitle
        });
    }
    else {
        addErrorNotification({
            id: failedToSaveNotificationId,
            messages: [displayText.errorFailedToSaveMessage],
            title: displayText.errorFailedToSaveTitle
        }, error);
    }
};
export const removeProceedErrorNotification = () => {
    removeNotification(seatsUnavailableNotificationId);
    removeNotification(failedToSaveNotificationId);
};
